import { render, staticRenderFns } from "./nav1.vue?vue&type=template&id=51d86cdf&scoped=true"
import script from "./nav1.vue?vue&type=script&lang=js"
export * from "./nav1.vue?vue&type=script&lang=js"
import style0 from "./nav1.vue?vue&type=style&index=0&id=51d86cdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d86cdf",
  null
  
)

export default component.exports